import { Injectable, signal } from '@angular/core';

/**
 * Bumped whenever the user navigates to (or re-selects) Earnings so the page always shows the password gate.
 */
@Injectable({ providedIn: 'root' })
export class VendorEarningsGateService {
  private readonly epoch = signal(0);

  /** Observable dependency for {@link EarningsPage} via `this.epoch()` in an effect. */
  gateEpoch(): number {
    return this.epoch();
  }

  requestPasswordGate(): void {
    this.epoch.update((n) => n + 1);
  }
}
